'use client';

import { Column, Row } from '../../../styles';
import { ProfilePicture } from '../../profile-picture/ProfilePicture';
import { Author } from '../../../types';
import { de } from 'date-fns/locale';
import { AuthorName, TimeDistance } from './styles';
import { formatDistance, isSameMinute } from 'date-fns';
import { useTranslations } from 'next-intl';

interface Props {
    author: Author;
    createdAt: Date;
    updatedAt: Date;
}

export const CommentInfo = ({ author, createdAt, updatedAt }: Props) => {
    const t = useTranslations('details');

    const now = new Date();

    const isUpdated = !isSameMinute(createdAt, updatedAt);
    const distance = formatDistance(updatedAt, now, {
        locale: de
    });

    return (
        <Row gap={2}>
            <ProfilePicture
                imageUrl={author.profilePicture?.url}
                altText={`Profile Picture of ${author.name}`}
            />
            <Column>
                <AuthorName>{author.name}</AuthorName>
                <TimeDistance italic={isUpdated}>
                    {t(isUpdated ? 'time_distance_updated' : 'time_distance_created', {
                        distance
                    })}
                </TimeDistance>
            </Column>
        </Row>
    );
};
